import NomenclatureFormController from './nomenclature.form.controller';

export default {
	template: require('./nomenclature.form.html'),
	controller: NomenclatureFormController
};
